import { makeIcon } from "components/ui/Icon";

export const NotEqualsOperatorIcon = makeIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <rect fill="var(--foreground)" height="24" rx="4" width="24" />
    <path d="M5 16V13.6H19V16H5ZM5 10.4V8H19V10.4H5Z" fill="var(--background)" />
    <path d="M8 20L16 4L17.5 4.8L9.5 20.8L8 20Z" fill="var(--background)" />
  </svg>,
);
